import * as React from "react";
import { Outlet } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import MuiDrawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Menu, MenuItem, Stack } from "@mui/material";
import { AccountCircle, ExpandMore, Logout } from "@mui/icons-material";
import  Sidemenu  from "./sidenavlist";
import { useNavigate } from "react-router-dom";
import Copyright from "../components/copyright";
import AppLogout from "../components/applogout";

const drawerWidth = 240;


const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
    backgroundColor: "lightgrey",
  },
}));

const mdTheme = createTheme({
  palette: {
    light: {
      main: "#F4F7FC",
      light: "#F9FAFC",
    },
    success: {
      main: "#27AE60",
      contrastText: "#fff",
    },
    grey: {
      main: "#BDBDBD",
      contrastText: "#fff",
    },
    warning: {
      main: "#F2994A",
      contrastText: "#fff",
    },
  },
});

function LayoutContent() {
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [currentUser, setCurrentUser] = React.useState({});

  const openMenu = Boolean(anchorEl);
  const navigate = useNavigate([]);
  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });
  const translatedText = JSON.parse(sessionStorage.getItem("TranslationText"));

  const toggleDrawer = () => {
    if (!isMobile) setOpen(!open);
  };

  const getCurrentUser = () => {
    let currentUserDetails = {
      id: 0,
      emailID: "",
      firstname: "",
      lastname: "",
      username: "",
      isLoggedIn: false,
      marketId: 0,
    };
    if (sessionStorage.getItem("authToken")) {
      const decodeUserDetails = JSON.parse(
        window.atob(sessionStorage.getItem("authToken").split(".")[1])
      );
      currentUserDetails.id = decodeUserDetails.Id;
      currentUserDetails.emailID = decodeUserDetails.EmailId;
      currentUserDetails.firstname = decodeUserDetails.FirstName;
      currentUserDetails.lastname = decodeUserDetails.LastName;
      currentUserDetails.username = decodeUserDetails.UserName;
      currentUserDetails.isLoggedIn = true;
      currentUserDetails.marketId = decodeUserDetails.MarketId;
    }
    setCurrentUser(currentUserDetails);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("authToken");
    navigate("/login");
  };

  React.useEffect(() => {
    getCurrentUser();
  }, []);

  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          position="absolute"
          open={open}
          sx={{ backgroundColor: "white" }}
        >
          <Toolbar
            sx={{
              pr: "24px", // keep right padding when drawer closed
            }}
          >
            <IconButton
              edge="start"
              aria-label="open drawer"
              onClick={toggleDrawer}
              sx={{
                marginRight: "36px",
                ...(open && { display: "none" }),
              }}
            >
              <MenuIcon />
            </IconButton>
            <Stack direction="row" flexGrow={1}>
              <img
                src={process.env.PUBLIC_URL + "/images/albaraneslogo.png"}
                alt="albaranes Logo"
                height="65"
                display="flex"
              />
              {/* <Divider orientation="vertical" variant="middle" flexItem />
              <img
                src={process.env.PUBLIC_URL + "/images/Attindas_LogoCrop.png"}
                alt="Indas Logo"
                height="30"
                display="flex"
              /> */}
            </Stack>
            <IconButton disabled fontSize="medium">
              <AccountCircle />
            </IconButton>

            <Typography color="black">
              {currentUser.firstname?.charAt(0)}
              {currentUser.lastname?.charAt(0)}
            </Typography>
            <IconButton
              id="demo-positioned-button"
              aria-controls={open ? "demo-positioned-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              <ExpandMore />
            </IconButton>
            <Menu
              id="profile"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              open={openMenu}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem
                onClick={handleClose}
                sx={{
                  display: "flex",
                  alignItems: "right",
                  justifyContent: "flex-end",
                  cursor: "default",
                  opacity: "1",
                  pointerEvents: "none",
                  fontSize: "16px",
                }}
              >
                {currentUser.firstname},{currentUser.lastname}
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                sx={{
                  display: "flex",
                  alignItems: "right",
                  justifyContent: "flex-end",
                  cursor: "default",
                  opacity: "1",
                  pointerEvents: "none",
                  fontSize: "14px",
                }}
              >
                {" "}
                {currentUser.emailID}
              </MenuItem>
              <Divider />
              <MenuItem
                onClick={handleLogout}
                sx={{
                  display: "flex",
                  alignItems: "right",
                  justifyContent: "flex-end",
                }}
              >
               <Logout sx={{ mr: "1ch" }} /> <span>{translatedText?.logout}</span>
              </MenuItem>
            </Menu>
          </Toolbar>
        </AppBar>
        <Drawer variant="permanent" open={open}>
          <Toolbar
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              px: [1],
            }}
          >
            <IconButton onClick={toggleDrawer}>
              <ChevronLeftIcon />
            </IconButton>
          </Toolbar>
          <Divider />
          <List component="nav">{<Sidemenu />}</List>
        </Drawer>
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "light"
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
          }}
        >
          <Toolbar />
          <Container maxWidth="xl" sx={{ mt: 1, mb: 1 }}>
            <Grid container>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Paper
                  sx={{
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <AppLogout>
                    <Outlet />
                  </AppLogout>
                </Paper>
              </Grid>
            </Grid>
            <Grid item xs={12}></Grid>
          </Container>
        </Box>
        <AppBar
          position="fixed"
          sx={{
            top: "auto",
            bottom: 0,
            backgroundColor: "#f5f5f5",
            zIndex: "0",
            boxShadow: "0",
          }}
        >
          <Copyright align="center" />
        </AppBar>
      </Box>
    </ThemeProvider>
  );
}

export default function Layout() {
  return <LayoutContent />;
}
